module.exports = __webpack_public_path__ + "img/back_closure_length.1208b757.png";